module.exports = __webpack_public_path__ + "img/to.3bd868b0.svg";